import { render, staticRenderFns } from "./Foro.vue?vue&type=template&id=65b72ecb&"
import script from "./Foro.vue?vue&type=script&lang=js&"
export * from "./Foro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports